import { getSessionId } from './session';

export const getGraphicCaptchaUrl = async () => {
  const sessioId = await getSessionId();
  const url = `/api-auth/api/graphicCaptchas?sessionId=${sessioId}&timestamp=${new Date().getTime()}`;
  return url;
};
